import React from "react";
import { NavLink, Link } from "react-router-dom";
import { Collapse } from "reactstrap";
import IconDown from "react-icons/lib/md/chevron-right";
import IconPDM from "react-icons/lib/md/extension";
import IconDashboard from "react-icons/lib/md/dashboard";

// icons
import IconSearch from "react-icons/lib/md/search";
import IataIcon from "react-icons/lib/md/landscape";
import Tsc from "react-icons/lib/ti/clipboard";
import IconManifest from "react-icons/lib/md/layers";
// import PdmDataEntry from 'react-icons/lib/fa/cloud-upload';
import PdmReport from "react-icons/lib/fa/edit";
// import UploadIcon from 'react-icons/lib/md/cloud-upload';
import InputIcon from "react-icons/lib/md/input";
import PdmDataEntry from "react-icons/lib/fa/cloud-upload";
import ReportsIcon from "react-icons/lib/md/insert-chart";
import FinalDestinationReportsIcon from "react-icons/lib/md/airport-shuttle";
import HelpIcon from "react-icons/lib/md/help-outline";
import UnbilledIcon from "react-icons/lib/md/unarchive";
import TicketSearch from "react-icons/lib/md/question-answer"
import FlightOperationIcon from "react-icons/lib/md/flight"
import PassengerIcon from "react-icons/lib/md/date-range"

const AdminMenuComponent = ({
  handleClick,
  selected,
  handleOpen,
  handleDataEntry,
}) => {
  return (
    <ul className="list-unstyled mt-3 nav-list clearfix">
      <li
        onClick={handleClick.bind(this, 0)}
        className={selected === 0 ? "selected" : ""}
      >
        <NavLink to="/">
          <IconDashboard size="18" />
          <span className="name">DashBoard</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 30)}
        className={selected === 30 ? "selected" : ""}
      >
        <Link to="#">
          <IconManifest size="18" />
          <span className="name">Manifest</span>
          <IconDown size="14" className="icon-down" />
        </Link>
        <Collapse isOpen={selected === 30} onClick={handleOpen.bind(this, 30)}>
          <ul className="inner-drop list-unstyled">
            <li>
              <NavLink to="#" onClick={handleDataEntry}>
                <InputIcon size="18" />
                <span className="name">Data Entry</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/search" activeClassName="active">
                <IconSearch size="18" />
                <span className="name">
                  Manifest
                  <br /> Report
                </span>
              </NavLink>   
            </li>
            <li>
              <NavLink to="/ticket-search" activeClassName="active">
                <TicketSearch size="18" />
                <span className="name">
                  Search By
                  <br /> Ticket
                </span>
              </NavLink>
            </li>
          </ul>
        </Collapse>
      </li>
      <li
        onClick={handleClick.bind(this, 4)}
        className={selected === 4 ? "selected" : ""}
      >
        <NavLink to="/iata" activeClassName="active">
          <IataIcon size="18" className="icon-flight-takeoff" />
          <span className="name">Iata Report</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 5)}
        className={selected === 5 ? "selected" : ""}
      >
        <NavLink to="/tsc" activeClassName="active">
          <Tsc size="18" className="icon-clipboard" />
          <span className="name">TSC Statement</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 11)}
        className={selected === 11 ? "selected" : ""}
      >
        <NavLink to="/reports" activeClassName="active">
          <ReportsIcon size="18" className="icon-insert-chart" />
          <span className="name">Reports</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 12)}
        className={selected === 12 ? "selected" : ""}
      >
        <NavLink to="/final-destination-reports" activeClassName="active">
          <FinalDestinationReportsIcon
            size="18"
            className="icon-insert-chart"
          />
          <span className="name">
            Final Destination <br /> Reports
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 31)}
        className={selected === 31 ? "selected" : ""}
      >
        <NavLink to="/security-charge-reports" activeClassName="active">
          <ReportsIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Security Charge <br /> Report
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 50)}
        className={selected === 50 ? "selected" : ""}
      >
        <Link to="#">
          <IconPDM size="18" />
          <span className="name">PDM</span>
          <IconDown size="14" className="icon-down" />
        </Link>
        <Collapse isOpen={selected === 50} onClick={handleOpen.bind(this, 50)}>
          <ul className="inner-drop list-unstyled">
            <li>
              <NavLink to="/pdm-report" activeClassName="active">
                <PdmReport size="18" className="FaEdit" />
                <span className="name">Report</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/pdm-data-entry" activeClassName="active">
                <PdmDataEntry size="18" className="icon-FaCloudUpload" />
                <span className="name">Data Entry</span>
              </NavLink>
            </li>
          </ul>
        </Collapse>
      </li>
      <li
        onClick={handleClick.bind(this, 60)}
        className={selected === 60 ? "selected" : ""}
      >
        <NavLink to="/billed-per-airport" activeClassName="active">
          <ReportsIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Billed per <br /> Airport
          </span>
        </NavLink>
      </li>


      <li
        onClick={handleClick.bind(this, 70)}
        className={selected === 70 ? "selected" : ""}
      >
        <NavLink to="/unbilled-passengers" activeClassName="active">
          <UnbilledIcon size="18" className="icon-insert-chart" />
          <span className="name">
          Unbilled <br /> Passenger
          </span>
        </NavLink>
      </li>
      <li>
        <NavLink to="/flight-operations" activeClassName="active">
          <FlightOperationIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Flight <br /> Operations
          </span>
        </NavLink>
      </li>
      <li
      >
        <NavLink to="/passenger-level-data" activeClassName="active">
          <PassengerIcon size="18" className="icon-insert-chart" />
          <span className="name">
           Passenger level <br /> Data
          </span>
        </NavLink>
      </li>
      {/* <li onClick={handleClick.bind(this, 108)} className={(selected === 108) ? 'selected': ''}>
                <NavLink to="/maker-checker" activeClassName="active">
                    <MakerCheckerIcon size="18" className="icon-insert-chart"/>
                    <span className="name">Maker <br/> Checker</span>
                </NavLink>
            </li> */}
      <hr></hr>


      <li
        onClick={handleClick.bind(this, 68)}
        className={selected === 68 ? "selected" : ""}
      >
        <NavLink to="/help-center" activeClassName="active">
          <HelpIcon size="18" className="icon-insert-chart" />
          <span className="name">Help Center</span>
        </NavLink>
      </li>
    </ul>
  );
};

export default AdminMenuComponent;



// WEBPACK FOOTER //
// ./src/shared/components/nav/menu/admin.js